module.exports = __webpack_public_path__ + "static/media/mixmash-screen.4d67fa86.png";